import Boss from "./animations/bosses/Boss";
import common from "./common";
import DifficultySystem from "./DifficultySystem";
import GUI from "./GUI";
import SaveData from "./SaveData";
import DeleteUserScene from "./scenes/DeleteUserScene";
import GameScene from "./scenes/GameScene";
import HelpScene from "./scenes/HelpScene";
import LootCrateScene from "./scenes/LootCrateScene";
import MapPreloaderScene from "./scenes/MapPreloaderScene";
import OverviewScene from "./scenes/OverviewScene";
import PauseScene from "./scenes/PauseScene";
import PreloaderScene from "./scenes/PreloaderScene";
import QuestionScene from "./scenes/QuestionScene";
import QuestionSceneSEAN from "./scenes/QuestionSceneSEAN";
import ResultScene from "./scenes/ResultScene";
import SplashScene from "./scenes/SplashScene";
import TrainingScene from "./scenes/TrainingScene";
import UserScene from "./scenes/UserScene";
import GelSettingsScene from "./ui/gel/GelSettingsScene";
import GelSubtitles from "./ui/gel/GelSubtitles";
import {isFossil, isIE11Win10} from "./utils";
import AchievementSystem from "./AchievementSystem";
import AchievementPopup from "./ui/AchievementPopup";
import AchievementScene from "./scenes/AchievementScene";
import Achievement from "./Achievement";
import moment from "moment";
import getParameter from "get-parameter";
import WeeklyChallenge from "./WeeklyChallenge";
import CharacterSelector from "./ui/CharacterSelector";

export default class Application {
    constructor() {
        common.save = new SaveData();

        this._loadedManifest = null;
        this._unlockedItem = null;
    }

    init() {
        if (common.debug){
            global.gui = new dat.GUI();
            common.gui = new GUI();
        }

        const locations = P3.utils.objectToArray(P3.assets.json("locations")).sort((a, b) => {
            return a.order - b.order;
        });
        common.location = locations[common.locationIndex];

        const achievements = new AchievementSystem();
        achievements.parseData(P3.utils.objectToArray(P3.assets.json("achievements")));
        common.achievements = achievements;

        const achievementPopup = new AchievementPopup();
        common.stage.addChild(achievementPopup);

        const user = common.save.getUserData(common.userId);
        const characters = P3.utils.objectToArray(P3.assets.json("characters"));
        common.character = characters.filter(x => x.skin === user.class)[0];

        common.difficulty = new DifficultySystem();

        this.initSubtitles();

        common.debug ? this.showQuestionScene() : this.showSplashScene();

        const seed = getParameter("seed");
        WeeklyChallenge.generate(seed !== "" ? [seed] : common.config.game.weekly_challenge_seeds);

        const exportcsv = getParameter("export");
        if (exportcsv === "true")
        {
            WeeklyChallenge.print();
        }

        const debugEquip = getParameter("debugEquip")
        if (debugEquip === "true")
        {
            const user = common.save.getUserData(common.userId);
            user.unlock["equip_purse"] = [1, 2, 3];
            user.unlock["equip_belt"] = [1, 2, 3];
            user.unlock["equip_band"] = [1, 2, 3];
            user.unlock["equip_amulet"] = [1, 2, 3, 4, 5, 6];
            user.unlock["equip_feather"] = [1, 2, 3];
            user.unlock["equip_purse"] = [1, 2, 3];
            user.unlock["equip_cloakfront,equip_cloakback"] = [1, 2, 3, 4, 5, 6];
            user.unlock["equip_shield"] = [1, 2, 3, 4, 5, 6];
            user.unlock["pet"] = [1, 2, 3];
            common.save.saveGame();
        }

        this.resetDayAchievement(user);

        //this.showQuestionScene();

        //this.showPauseScene();

        //const xp = this.levelComplete(10, 10000);
        //this.showResultScene(0, 10, xp, true);

        //const item = common.save.unlockRandomItem();
        //this.showLootCrateScene(item);

        //P3.audio.mute(true);
    }

    showRequiredAssetPreloader()
    {
        const scene = new PreloaderScene();
        scene.autoAppear = false;

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    showSplashScene() {
        const scene = new SplashScene();
        scene.autoAppear = false;

        scene.signals.next.add(() => {
            if (common.requiredAssetsReady)
            {
                this.showUserScene();
                //this.showResultScene(
                //    0,
                //    0,
                //    {from: 0, to: 1, current: 0, target: 1},
                //    true,
                //    [true, true, false, false, false, false, false, false, false, false], true
                //);
                //this.showLootCrateScene(null, false, true);
            }
            else
            {
                const preloader = this.showRequiredAssetPreloader();
                preloader.signals.next.add(() => this.showUserScene(), this);
                //preloader.signals.next.add(() => this.showResultScene(
                //    0,
                //    0,
                //    {from: 0, to: 1, current: 0, target: 1},
                //    true,
                //    [true, true, false, false, false, false, false, false, false, false], true
                //), this);
                //preloader.signals.next.add(() => this.showLootCrateScene(null, false, true), this);
            }
        });
        scene.signals.settings.add(() => {
            this.showSettingsScene();
        });
        scene.signals.exit.add(() => {
            common.gmi.exit();
        });
        scene.signals.help.add(() => {
            const help = this.showHelpScene();
            help.signals.previous.add(() => {
                this.showSplashScene();
            }, null, 1);
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        P3.audio.playMusic("music_mathematica_main_theme");

        return scene;
    }

    showUserScene() {
        const scene = new UserScene();
        scene.autoAppear = false;

        scene.signals.next.add(() => {
            const user = common.save.getUserData(common.userId);
            const finishedTraining = user.finishedTraining;

            const locations = P3.utils.objectToArray(P3.assets.json("locations")).sort((a, b) => {
                return a.order - b.order;
            });
            common.locationIndex = user.location;
            common.location = locations[user.location];

            const characters = P3.utils.objectToArray(P3.assets.json("characters"));
            common.character = characters.filter(x => x.skin === user.class)[0];

            this.showOverviewScene(finishedTraining);
        });
        scene.signals.previous.add(() => {
            this.showSplashScene();
        });
        scene.signals.settings.add(() => {
            this.showSettingsScene();
        });
        scene.signals.deleteUser.add((scene, id) => {
            const confirm = this.showDeleteUserScene();
            confirm.signals.next.add(() => {
                scene.deleteUser(id);
            }, null, 1);
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        return scene;
    }

    showDeleteUserScene() {
        const scene = new DeleteUserScene();

        scene.signals.next.add(() => {
            P3.scene.remove();
        });
        scene.signals.previous.add(() => {
            P3.scene.remove();
        });

        P3.scene.add(scene, false);
        return scene;
    }

    showOverviewScene(finishedTraining = true, gotoPage = null, weaponReveal = false) {
        const scene = new OverviewScene(finishedTraining, gotoPage, weaponReveal);
        scene.autoAppear = false;

        scene.signals.next.add(() => {
            const bosses = P3.assets.json("bosses");
            if (common.config.game.debug_boss === "") {
                let type = P3.utils.selectRandom([
                    Boss.TYPE_DRAGON,
                    Boss.TYPE_SPIDER,
                    Boss.TYPE_MAGE,
                    Boss.TYPE_SPIRIT,
                    Boss.TYPE_HOBGOBLIN,
                    Boss.TYPE_TROLL
                ]);

                // hotfix for statistics - dragon is too big and gets hidden
                if (common.location.id === "statistics" && type === Boss.TYPE_DRAGON) {
                    type = Boss.TYPE_SPIDER;
                }

                if (common.location.challenge)
                {
                    type = Boss.TYPE_GOLDEN_DRAGON;
                }

                common.boss = bosses.filter(x => x.type === type)[0];
            } else {
                common.boss = bosses.filter(x => x.type === common.config.game.debug_boss)[0];
            }

            const manifest = this.createManifest(common.location, common.boss.type);
            this.loadLevel(manifest);
            this._loadedManifest = manifest;
        });
        scene.signals.previous.add(() => {
            this.showUserScene();
        });
        scene.signals.settings.add(() => {
            this.showSettingsScene();
        });
        scene.signals.achievements.add(() =>
        {
            let gotoPage = null;

            if (scene.editCharacter)
            {
                if (scene.characterSelector.mode === CharacterSelector.MODE_CHARACTER)
                {
                    gotoPage = {type: OverviewScene.PAGE_CHARACTER};
                }
                else if (scene.characterSelector.mode === CharacterSelector.MODE_ITEM)
                {
                    gotoPage = {type: OverviewScene.PAGE_ITEM};
                }
            }

            this.showAchievementScene(gotoPage);
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        P3.audio.playMusic("music_avatar_loop_00");

        return scene;
    }

    showGameScene() {
        const scene = new GameScene();
        scene.autoAppear = false;

        scene.signals.next.add((scene, correctCount, questionCount, totalXp, victory, answers) => {

            let challengeComplete = false;
            if (common.location.challenge && victory)
            {
                if (common.save.completeWeeklyChallenge(common.userId))
                {
                    challengeComplete = true;
                }
            }

            const xp = this.levelComplete(correctCount, totalXp, victory);
            this.showResultScene(correctCount, questionCount, xp, victory, answers, challengeComplete);
        });
        scene.signals.previous.add(() => {
            this.showOverviewScene();
        });
        scene.signals.pause.add(() => {
            this.showPauseScene();
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    showMapPreloader() {
        const scene = new MapPreloaderScene();
        scene.autoAppear = false;

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    showTrainingScene() {
        const user = common.save.getUserData(common.userId);

        const scene = new TrainingScene();
        scene.autoAppear = false;

        scene.signals.next.add(() => {
            if (!user.finishedTraining) {
                user.finishedTraining = true;

                const xp = this.levelComplete(3, common.config.game.level_progression[0]);
                this.showResultScene(3, 3, xp, true, [true, true, true]);

                common.save.saveGame();
            } else {
                this.showOverviewScene(user.finishedTraining);
            }
        });
        scene.signals.pause.add(() => {
            this.showPauseScene();
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    showPauseScene(swap = false) {
        const user = common.save.getUserData(common.userId);

        const scene = new PauseScene();

        scene.signals.home.add(() => {
            this.showOverviewScene(user.finishedTraining);
        });
        scene.signals.restart.add(() => {
            common.location.training ? this.showTrainingScene() : this.showGameScene();
        });
        scene.signals.help.add(() => {
            const help = this.showHelpScene(true);
            help.signals.previous.add(() => {
                this.showPauseScene(true);
            }, null, 1);
        });
        scene.signals.settings.add(() => {
            this.showSettingsScene();
        });
        scene.signals.next.add(() => {
            P3.scene.remove();
        });

        if (swap) P3.scene.swap(scene);
        else P3.scene.add(scene);

        P3.audio.playMusic("music_pause_menu");

        return scene;
    }

    showSettingsScene() {
        const scene = new GelSettingsScene();

        scene.signals.next.add(() => {
            P3.scene.remove();
        });
        P3.scene.add(scene);
        return scene;
    }

    showHelpScene(swap = false) {
        const scene = new HelpScene();
        scene.autoAppear = false;

        scene.signals.settings.add(() => {
            this.showSettingsScene();
        });

        this.fadeTransition(() => {
            if (swap) P3.scene.swap(scene);
            else P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    showResultScene(score, total, xp = {from: 0, to: 1, current: 0, target: 1}, victory = false, answers = [], challengeComplete = false) {
        const scene = new ResultScene(score, total, xp, victory, answers);
        scene.autoAppear = false;

        scene.signals.home.add(() => {
            this.showSplashScene();
        });
        scene.signals.settings.add(() => {
            this.showSettingsScene();
        });
        scene.signals.next.add(() => {
            const user = common.save.getUserData(common.userId);
            if (user.loot || challengeComplete)
            {
                this.showLootCrateScene(this._unlockedItem, user.loot, challengeComplete);
                this._unlockedItem = null;
                
                user.loot = false;
                common.save.saveGame();
            }
            else
            {
                this.showOverviewScene(true);
            }

            // shift the level to the next - if we are training
            const locations = P3.utils.objectToArray(P3.assets.json("locations")).sort((a, b) => {
                return a.order - b.order;
            });

            if (common.locationIndex === 0) {
                common.locationIndex = user.location = 1;
                common.location = locations[user.location];
                common.save.saveGame();
            }
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        P3.audio.playMusic("music_results_loop");

        return scene;
    }

    showLootCrateScene(item, showItem = true, showOrb = false) {
        const scene = new LootCrateScene(item, showItem, showOrb);

        scene.signals.next.add(() => {
            const user = common.save.getUserData(common.userId);

            let slot = item.slot;
            if (!Array.isArray(slot)) {
                slot = [slot];
            }

            for (let i = 0; i < slot.length; ++i) {
                user.equipment[slot[i]] = item.type;
            }

            common.save.saveGame();

            this.showOverviewScene(true, {type: OverviewScene.PAGE_ITEM, item: item}, showOrb);
        });
        scene.signals.previous.add(() => {
            this.showOverviewScene(true, null, showOrb);
        });

        P3.scene.add(scene, false);
        return scene;
    }

    showAchievementScene(gotoPage = null)
    {
        const scene = new AchievementScene();
        scene.autoAppear = false;

        scene.signals.previous.add(() =>
        {
            const user = common.save.getUserData(common.userId);
            const finishedTraining = user.finishedTraining;

            this.showOverviewScene(finishedTraining, gotoPage);
        });

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    showQuestionScene() {
        const scene = common.debug ? new QuestionSceneSEAN() : new QuestionScene();
        scene.autoAppear = false;

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });
        return scene;
    }

    createManifest(location, bossType) {
        const bosses = P3.utils.objectToArray(P3.assets.json("bosses"));
        const t = bosses.filter(x => x.type === bossType)[0];

        let manifest = [
            {name: location.theme.bg, url: "images/environments/" + location.path + location.theme.bg + "_0.5x" + ".jpg"},
            {name: location.theme.fg, url: "images/environments/" + location.path + location.theme.fg + "_0.5x" + ".png"},
            {name: location.theme.left, url: "images/environments/" + location.path + location.theme.left + "_0.5x" + ".png"},
            {name: location.theme.right, url: "images/environments/" + location.path + location.theme.right + "_0.5x" + ".png"}
        ];

        if (/*!isEdge18() &&*/ !isIE11Win10()) {
            manifest.push({name: location.audio.ambience, url: "audio/mono/" + location.audio.ambience + P3.assets.audioFileExt});

            for (let i = 0; i < t.audio.vo.taunt.generic.length; ++i) {
                const name = t.audio.vo.taunt.generic[i];
                manifest.push({name: name, url: "audio/mono/vos/" + (t.path ? t.path : t.type) + "/" + name + P3.assets.audioFileExt});
            }
            for (let i = 0; i < t.audio.vo.taunt.location[location.id].length; ++i) {
                const name = t.audio.vo.taunt.location[location.id][i];
                manifest.push({name: name, url: "audio/mono/vos/" + (t.path ? t.path : t.type) + "/" + name + P3.assets.audioFileExt});
            }
            for (let i = 0; i < t.audio.vo.damage.length; ++i) {
                const name = t.audio.vo.damage[i];
                manifest.push({name: name, url: "audio/mono/vos/" + (t.path ? t.path : t.type) + "/" + name + P3.assets.audioFileExt});
            }
            for (let i = 0; i < t.audio.vo.attack.length; ++i) {
                const name = t.audio.vo.attack[i];
                manifest.push({name: name, url: "audio/mono/vos/" + (t.path ? t.path : t.type) + "/" + name + P3.assets.audioFileExt});
            }

            /*
            if (isFossil()) {
                for (let i = 0; i < t.audio.vo.taunt.generic.length; ++i) {
                    const name = t.audio.vo.taunt.generic[i];
                    manifest.push({name: name, url: "audio/mono/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
                for (let i = 0; i < t.audio.vo.taunt.location[location.id].length; ++i) {
                    const name = t.audio.vo.taunt.location[location.id][i];
                    manifest.push({name: name, url: "audio/mono/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
                for (let i = 0; i < t.audio.vo.damage.length; ++i) {
                    const name = t.audio.vo.damage[i];
                    manifest.push({name: name, url: "audio/mono/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
                for (let i = 0; i < t.audio.vo.attack.length; ++i) {
                    const name = t.audio.vo.attack[i];
                    manifest.push({name: name, url: "audio/mono/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
            } else {
                for (let i = 0; i < t.audio.vo.taunt.generic.length; ++i) {
                    const name = t.audio.vo.taunt.generic[i];
                    manifest.push({name: name, url: "audio/stereo/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
                for (let i = 0; i < t.audio.vo.taunt.location[location.id].length; ++i) {
                    const name = t.audio.vo.taunt.location[location.id][i];
                    manifest.push({name: name, url: "audio/stereo/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
                for (let i = 0; i < t.audio.vo.damage.length; ++i) {
                    const name = t.audio.vo.damage[i];
                    manifest.push({name: name, url: "audio/stereo/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
                for (let i = 0; i < t.audio.vo.attack.length; ++i) {
                    const name = t.audio.vo.attack[i];
                    manifest.push({name: name, url: "audio/stereo/vos/" + t.type + "/" + name + P3.assets.audioFileExt});
                }
            }
            */
        }
        return manifest;
    }

    loadLevel(manifest) {
        this.unloadLevel(this._loadedManifest);

        console.log(manifest);
        if (manifest.length) {
            const arr = ["tutorial"];
            let preloader;
            if (arr.indexOf(common.location.id) !== -1) {
                preloader = new PreloaderScene(false);
            } else {
                preloader = new MapPreloaderScene();
            }
            preloader.autoAppear = false;
            preloader.signals.next.add(() => {
                common.location.training ? this.showTrainingScene() : this.showGameScene();
            });

            const basePath = common.gmi ? common.gmi.gameDir : "./";
            P3.assets.addFiles(manifest, basePath + "assets/");

            this.fadeTransition(() => {
                P3.scene.show(preloader);
            }, () => {
                P3.assets.load();
                preloader.appear();
            });
        }
    }

    unloadLevel(manifest) {
        if (manifest && manifest.length) {
            for (let i = 0; i < manifest.length; ++i) {
                const asset = manifest[i];
                const split = asset.url.split(".");
                const extension = split[split.length - 1];

                if (P3.assets.audioFileTypes.indexOf(extension) !== -1) {
                    P3.audio.unloadSound(asset.name);
                } else {
                    P3.assets.unloadTexture(asset.name, extension);
                }
            }
        }
    }

    levelComplete(correctCount, totalXp, victory) {
        const user          = common.save.getUserData(common.userId);
        const progression   = P3.utils.objectToArray(common.config.game.level_progression);
        let target          = progression[Math.min(progression.length - 1, user.level)];
        const from          = Math.max(0, Math.min(1, user.xp / target));
        const to            = Math.max(0, Math.min(1, (user.xp + totalXp) / target));
        let extra           = Math.max(0, (user.xp + totalXp) - target);

        console.log("xp:", {start: user.xp, end: totalXp, target: target, from: from, to: to, extra: extra});

        const index = Math.max(0, Math.min(progression.length - 1, user.level));
        if (user.xp + totalXp >= progression[index]) {
            this._unlockedItem = common.save.unlockRandomItem();
            user.loot = this._unlockedItem !== null;
            ++user.level;

            const nextTarget = progression[Math.min(progression.length - 1, user.level)];
            if (extra > nextTarget) {
                extra = nextTarget * 0.6;
                console.log("adjusted extra xp:", extra);
            }
            user.xp = extra;
        } else {
            user.xp += totalXp;
        }
        user.totalXp += totalXp;

        if (user.loot)
        {
            this.unlockEquipmentAchievement(user);
        }

        if (victory)
        {
            ++user.victory;

            this.unlockChallengeAchievement(user);
            this.unlockDayAchievement(user);
            this.unlockBossAchievement(user);
        }

        common.save.saveGame();

        console.log("new xp:", user.xp);

        common.difficulty.setProgression(correctCount);

        // tracking
        common.gmi.sendStatsEvent("xpincrease", "true", {
            metadata: "XPL=" + user.totalXp
        });

        // achievements
        common.achievements.setProgress(Achievement.XP_LEVEL1, user.totalXp / 100);
        common.achievements.setProgress(Achievement.XP_LEVEL2, user.totalXp / 200);
        common.achievements.setProgress(Achievement.XP_LEVEL3, user.totalXp / 500);
        common.achievements.setProgress(Achievement.XP_LEVEL4, user.totalXp / 750);
        common.achievements.setProgress(Achievement.XP_LEVEL5, user.totalXp / 1000);
        common.achievements.setProgress(Achievement.XP_LEVEL6, user.totalXp / 1500);
        common.achievements.setProgress(Achievement.XP_LEVEL7, user.totalXp / 2000);

        return {from: from, to: to, current: target * to, target: target};
    }

    unlockDayAchievement(user)
    {
        if (common.location.challenge || common.location.modules.all)
            return;

        user.streak[user.location] = true;

        let count = 0;
        for (const i in user.streak)
        {
            if (user.streak[i])
            {
                ++count;
            }
        }

        common.save.saveGame();

        common.achievements.setProgress(Achievement.COMPLETE_TWO_TOPIC_DAY, count / 2);
        if (count > 1)
        {
            common.achievements.unlock(Achievement.COMPLETE_TWO_TOPIC_DAY);
        }
    }

    resetDayAchievement(user)
    {
        const days = common.days;
        if (days !== user.timestamp)
        {
            user.timestamp = days;
            user.streak = {};

            common.achievements.setProgress(Achievement.COMPLETE_TWO_TOPIC_DAY, 0, true);
        }
    }

    unlockChallengeAchievement(user)
    {
        common.achievements.setProgress(Achievement.COMPLETE_CHALLENGES_LEVEL1, user.victory / 5);
        if (user.victory >= 5)
            common.achievements.unlock(Achievement.COMPLETE_CHALLENGES_LEVEL1);

        common.achievements.setProgress(Achievement.COMPLETE_CHALLENGES_LEVEL2, user.victory / 10);
        if (user.victory >= 10)
            common.achievements.unlock(Achievement.COMPLETE_CHALLENGES_LEVEL2);

        common.achievements.setProgress(Achievement.COMPLETE_CHALLENGES_LEVEL3, user.victory / 20);
        if (user.victory >= 20)
            common.achievements.unlock(Achievement.COMPLETE_CHALLENGES_LEVEL3);

        common.achievements.setProgress(Achievement.COMPLETE_CHALLENGES_LEVEL4, user.victory / 50);
        if (user.victory >= 50)
            common.achievements.unlock(Achievement.COMPLETE_CHALLENGES_LEVEL4);

        common.achievements.setProgress(Achievement.COMPLETE_CHALLENGES_LEVEL5, user.victory / 100);
        if (user.victory >= 100)
            common.achievements.unlock(Achievement.COMPLETE_CHALLENGES_LEVEL5);
    }

    unlockBossAchievement(user)
    {
        const type = common.boss.type;
        let count = user.bosses[type] || 0;
        user.bosses[type] = ++count;

        switch (type)
        {
            case Boss.TYPE_DRAGON :
            {
                common.achievements.setProgress(Achievement.COMPLETE_DRAGON_LEVEL1, count / 5);
                if (count >= 5)
                    common.achievements.unlock(Achievement.COMPLETE_DRAGON_LEVEL1);

                common.achievements.setProgress(Achievement.COMPLETE_DRAGON_LEVEL2, count / 10);
                if (count >= 10)
                    common.achievements.unlock(Achievement.COMPLETE_DRAGON_LEVEL2);

                common.achievements.setProgress(Achievement.COMPLETE_DRAGON_LEVEL3, count / 20);
                if (count >= 20)
                    common.achievements.unlock(Achievement.COMPLETE_DRAGON_LEVEL3);

                common.achievements.setProgress(Achievement.COMPLETE_DRAGON_LEVEL4, count / 50);
                if (count >= 50)
                    common.achievements.unlock(Achievement.COMPLETE_DRAGON_LEVEL4);

                common.achievements.setProgress(Achievement.COMPLETE_DRAGON_LEVEL5, count / 100);
                if (count >= 100)
                    common.achievements.unlock(Achievement.COMPLETE_DRAGON_LEVEL5);

                break;
            }
            case Boss.TYPE_HOBGOBLIN :
            {
                common.achievements.setProgress(Achievement.COMPLETE_HOBGOBLIN_LEVEL1, count / 5);
                if (count >= 5)
                    common.achievements.unlock(Achievement.COMPLETE_HOBGOBLIN_LEVEL1);

                common.achievements.setProgress(Achievement.COMPLETE_HOBGOBLIN_LEVEL2, count / 10);
                if (count >= 10)
                    common.achievements.unlock(Achievement.COMPLETE_HOBGOBLIN_LEVEL2);

                common.achievements.setProgress(Achievement.COMPLETE_HOBGOBLIN_LEVEL3, count / 20);
                if (count >= 20)
                    common.achievements.unlock(Achievement.COMPLETE_HOBGOBLIN_LEVEL3);

                common.achievements.setProgress(Achievement.COMPLETE_HOBGOBLIN_LEVEL4, count / 50);
                if (count >= 50)
                    common.achievements.unlock(Achievement.COMPLETE_HOBGOBLIN_LEVEL4);

                common.achievements.setProgress(Achievement.COMPLETE_HOBGOBLIN_LEVEL5, count / 100);
                if (count >= 100)
                    common.achievements.unlock(Achievement.COMPLETE_HOBGOBLIN_LEVEL5);

                break;
            }
            case Boss.TYPE_MAGE :
            {
                common.achievements.setProgress(Achievement.COMPLETE_MAGE_LEVEL1, count / 5);
                if (count >= 5)
                    common.achievements.unlock(Achievement.COMPLETE_MAGE_LEVEL1);

                common.achievements.setProgress(Achievement.COMPLETE_MAGE_LEVEL2, count / 10);
                if (count >= 10)
                    common.achievements.unlock(Achievement.COMPLETE_MAGE_LEVEL2);

                common.achievements.setProgress(Achievement.COMPLETE_MAGE_LEVEL3, count / 20);
                if (count >= 20)
                    common.achievements.unlock(Achievement.COMPLETE_MAGE_LEVEL3);

                common.achievements.setProgress(Achievement.COMPLETE_MAGE_LEVEL4, count / 50);
                if (count >= 50)
                    common.achievements.unlock(Achievement.COMPLETE_MAGE_LEVEL4);

                common.achievements.setProgress(Achievement.COMPLETE_MAGE_LEVEL5, count / 100);
                if (count >= 100)
                    common.achievements.unlock(Achievement.COMPLETE_MAGE_LEVEL5);

                break;
            }
            case Boss.TYPE_SPIDER :
            {
                common.achievements.setProgress(Achievement.COMPLETE_SPIDER_LEVEL1, count / 5);
                if (count >= 5)
                    common.achievements.unlock(Achievement.COMPLETE_SPIDER_LEVEL1);

                common.achievements.setProgress(Achievement.COMPLETE_SPIDER_LEVEL2, count / 10);
                if (count >= 10)
                    common.achievements.unlock(Achievement.COMPLETE_SPIDER_LEVEL2);

                common.achievements.setProgress(Achievement.COMPLETE_SPIDER_LEVEL3, count / 20);
                if (count >= 20)
                    common.achievements.unlock(Achievement.COMPLETE_SPIDER_LEVEL3);

                common.achievements.setProgress(Achievement.COMPLETE_SPIDER_LEVEL4, count / 50);
                if (count >= 50)
                    common.achievements.unlock(Achievement.COMPLETE_SPIDER_LEVEL4);

                common.achievements.setProgress(Achievement.COMPLETE_SPIDER_LEVEL5, count / 100);
                if (count >= 100)
                    common.achievements.unlock(Achievement.COMPLETE_SPIDER_LEVEL5);

                break;
            }
            case Boss.TYPE_SPIRIT :
            {
                common.achievements.setProgress(Achievement.COMPLETE_SPIRIT_LEVEL1, count / 5);
                if (count >= 5)
                    common.achievements.unlock(Achievement.COMPLETE_SPIRIT_LEVEL1);

                common.achievements.setProgress(Achievement.COMPLETE_SPIRIT_LEVEL2, count / 10);
                if (count >= 10)
                    common.achievements.unlock(Achievement.COMPLETE_SPIRIT_LEVEL2);

                common.achievements.setProgress(Achievement.COMPLETE_SPIRIT_LEVEL3, count / 20);
                if (count >= 20)
                    common.achievements.unlock(Achievement.COMPLETE_SPIRIT_LEVEL3);

                common.achievements.setProgress(Achievement.COMPLETE_SPIRIT_LEVEL4, count / 50);
                if (count >= 50)
                    common.achievements.unlock(Achievement.COMPLETE_SPIRIT_LEVEL4);

                common.achievements.setProgress(Achievement.COMPLETE_SPIRIT_LEVEL5, count / 100);
                if (count >= 100)
                    common.achievements.unlock(Achievement.COMPLETE_SPIRIT_LEVEL5);

                break;
            }
            case Boss.TYPE_TROLL :
            {
                common.achievements.setProgress(Achievement.COMPLETE_TROLL_LEVEL1, count / 5);
                if (count >= 5)
                    common.achievements.unlock(Achievement.COMPLETE_TROLL_LEVEL1);

                common.achievements.setProgress(Achievement.COMPLETE_TROLL_LEVEL2, count / 10);
                if (count >= 10)
                    common.achievements.unlock(Achievement.COMPLETE_TROLL_LEVEL2);

                common.achievements.setProgress(Achievement.COMPLETE_TROLL_LEVEL3, count / 20);
                if (count >= 20)
                    common.achievements.unlock(Achievement.COMPLETE_TROLL_LEVEL3);

                common.achievements.setProgress(Achievement.COMPLETE_TROLL_LEVEL4, count / 50);
                if (count >= 50)
                    common.achievements.unlock(Achievement.COMPLETE_TROLL_LEVEL4);

                common.achievements.setProgress(Achievement.COMPLETE_TROLL_LEVEL5, count / 100);
                if (count >= 100)
                    common.achievements.unlock(Achievement.COMPLETE_TROLL_LEVEL5);

                break;
            }
        }
    }

    unlockEquipmentAchievement(user)
    {
        const purse = user.unlock["equip_purse"];
        if (Array.isArray(purse))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_PURSES, purse.length / 4, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_PURSES;
            }
        }

        const belt = user.unlock["equip_belt"];
        if (Array.isArray(belt))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_BELTS, belt.length / 4, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_BELTS;
            }
        }

        const band = user.unlock["equip_band"];
        if (Array.isArray(band))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_BRACELETS, band.length / 4, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_BRACELETS;
            }
        }

        const amulet = user.unlock["equip_amulet"];
        if (Array.isArray(amulet))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_AMULETS, amulet.length / 7, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_AMULETS;
            }
        }

        const feather = user.unlock["equip_feather"];
        if (Array.isArray(feather))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_FEATHERS, feather.length / 4, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_FEATHERS;
            }
        }

        const cloak = user.unlock["equip_cloakfront,equip_cloakback"];
        if (Array.isArray(cloak))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_CLOAKS, cloak.length / 7, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_CLOAKS;
            }
        }

        const shield = user.unlock["equip_shield"];
        if (Array.isArray(shield))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_SHIELDS, shield.length / 7, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_SHIELDS;
            }
        }

        const pet = user.unlock["pet"];
        if (Array.isArray(pet))
        {
            if (common.achievements.setProgress(Achievement.UNLOCK_ALL_PETS, pet.length / 4, false, AchievementSystem.SETTING_FORCE_HIDDEN))
            {
                common.equipmentAchievement = Achievement.UNLOCK_ALL_PETS;
            }
        }
    }

    fadeTransition(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0x0);
        common.transitions.addChild(transition);

        transition.signals.in.add(() => {
            transition.out();
            a && a.call(scope);
        });
        transition.signals.out.add(() => {
            transition.destroy();
            b && b.call(scope);
        });
        transition.in();
    }

    initSubtitles() {
        const settings = common.gmi.getAllSettings();
        const subtitles = new GelSubtitles();
        subtitles.visible = settings.subtitles;
        common.subtitles = subtitles;

        P3.audio.signals.vo.add((audio, name, vo) =>
        {
            show(name, vo ? vo.howl.duration() : 3)
        });

        P3.audio.signals.button.add((audio, name, vo) =>
        {
            if (settings.gameData ? settings.gameData.button_audio : false) {
                show(name, vo ? vo.howl.duration() : 1);
            }
        });

        const show = (name, duration = 2) =>
        {
            const data = P3.assets.json("subtitles");
            common.subtitles.show(data[name] ? data[name] : name, duration);
        }
    }
}